import axios from 'axios';
import _ from 'lodash';
import { push } from 'connected-react-router';
import { SubmissionError, change } from 'redux-form';
import { SIGN_UP_FORM_ID, NETWORK } from '../../../framework/App/AppConstants';
import setUrl from '../../../framework/App/SetUrl';
import { PAGE_NAME } from '../../../US/config/pageNames';
import { NEW_CUST_API } from '../../../US/config/apiEndpoints';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { scrollToTop } from '../../../framework/App/SkeletonPage/SkeletonPageActions';
import { processSubmissionErrors } from '../../../shared-components/FormElement/FormElementUtils';
import {safeStringify} from '../../../../../server/src/CAP/GPL/util/stringUtil';

export const handleRedirect = (response) => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};


export const submitNewCustomerApplication = (data, localePrefix) => (dispatch, getState) => {
    const state = getState();
    const { serverData = {} } = getState();
    const { _csrf = '', showCYCO = false, cycoFinancingOptions = [] } = serverData;
    const creditTypeIsNI = _.some(cycoFinancingOptions, option => _.get(option, 'credit_financing.credit_type') === 'NI');
    return axios
        .request({
            url: NEW_CUST_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data
        })
        .then(response => {
            if (_.get(response, 'data.validation.errors.emailNotAvailable')) {
                dispatch(spinnerClose());
                capeLog && capeLog('email not available');
                capeLog && capeLog(`showCaptcha:  ${_.get(response, 'data.validation.showCaptcha')}`);
                dispatch(setServerData({validationErrorModel:  _.get(response, 'data.validation')}));
                dispatch(setServerData({showCaptcha:  _.get(response, 'data.validation.showCaptcha')}));
                dispatch(change(SIGN_UP_FORM_ID, 'password', ''));
                dispatch(change(SIGN_UP_FORM_ID, 'confirmPassword', ''));
            } else if (!_.isEmpty(_.get(response, 'data.validation.errors'))) {
                dispatch(scrollToTop());
                dispatch(spinnerClose());
                dispatch(setServerData({captchaImgUrl: _.get(response, 'data.captchaImgUrl')}));
                dispatch(setServerData({captchaAudioUrl: _.get(response, 'data.captchaAudioUrl')}));
                dispatch(setServerData({validationErrorModel:  _.get(response, 'data.validation')}));
                dispatch(change(SIGN_UP_FORM_ID, 'captchaInput', ''));
                dispatch(change(SIGN_UP_FORM_ID, 'password', ''));
                dispatch(change(SIGN_UP_FORM_ID, 'confirmPassword', ''));
                capeLog && capeLog(`submitApplicationApi:us:response: server validation error: ${safeStringify(response.data.validation.errors)}`);
                return Promise.reject(new SubmissionError(processSubmissionErrors(response.data.validation.errors.fieldError, localePrefix), state));
            } else {
                if (handleRedirect(response)) {
                    return;
                }
                dispatch(spinnerClose());
                dispatch(setServerData({email: _.get(response, 'data.validation.email')}));

                let nextPage = PAGE_NAME.BILLING_PAGE;
                if (showCYCO && creditTypeIsNI) {
                    nextPage = PAGE_NAME.CYCO_PAGE;
                } else if (showCYCO && !creditTypeIsNI) {
                    nextPage = PAGE_NAME.CYCO_CORE_PAGE;
                }

                dispatch(push(nextPage));
            }
        })
        .catch(error => {
            if (error instanceof SubmissionError) {
                return Promise.reject(error);
            }
            capeLog && capeLog('response:error, US_NewCustomerPageActions,' + (error && error.message));
            if (handleRedirect(error && error.response)) {
                return;
            }

            if (_.get(error, 'response.data.err', false)) {
                dispatch(setServerData({errorModel: _.get(error, 'response.data', {})}));
                dispatch(push(PAGE_NAME.ERROR_PAGE));
                dispatch(spinnerClose());
            } else {
                // should never be here
                capeLog && capeLog('response:error: unexpected error response for New Customer page submit');
                setUrl(window, PAGE_NAME.NEWCUST_PAGE);
            }
        });
};
